<template>
  <div>
    <div style="margin-bottom: 20px;margin-top: 30px">
      <router-view></router-view>
      <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      <el-button size="small" type="danger" icon="el-icon-delete" @click="deleteInfo()">批量删除</el-button>
    </div>
    <div style="width:100%;">
      <w-table :columns="column" :table-data="tableData" @rowSelection="rowSelection"
               @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
               :table-col-check="{isShow:true,name:'-Reminder2'}" ref="wMyTable"
               :page="page" @pageChange="handlePagePagination" :isShowRowSelection="true">
        <div slot="operation" slot-scope="{record}">
          <el-button size="mini" type="primary" @click="handleEdit(record)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteInfo(record)">删除</el-button>
        </div>
        <div slot="doneFlag" slot-scope="{text,record}">
          <div class="status-tag-container">
            <el-tag v-if="text === 1" type="success">是</el-tag>
            <el-tag v-else-if="text === 0" type="warning">否</el-tag>
            <el-tag v-else type="info">未知状态</el-tag>
          </div>
        </div>
        <div slot="invoiceRecordId" slot-scope="{text,record}">
          <div class="status-tag-container">
            <el-link type="primary" :underline="false" @click="showRecordInfo(text)">
              <i v-html="viewDetailIcon"></i>查看发票记录
            </el-link>
          </div>
        </div>
        <div slot="mailInfoId" slot-scope="{text,record}">
          <div class="status-tag-container">
            <el-link type="primary" :underline="false"  @click="showMailInfo(text)">
              <i v-html="viewDetailIcon"></i>查看邮寄记录
            </el-link>
          </div>
        </div>
        <div slot="remindersTimes" slot-scope="{text,record,index}">
          <ex-fold-form :scope="{time:text, index,type:'reminder'}"></ex-fold-form>
        </div>
      </w-table>
      <add-edit-reminder :select-detail="selectDetail" :select-type="selectType" @submit="closeAddEditDialog"
                         :show-reminder="showAddEditDialog" v-if="showAddEditDialog"></add-edit-reminder>
      <mail-details v-if="showMailDetails" :show-dialog="showMailDetails"
                    :select-detail="MailDetails" @submit="close1">
      </mail-details>
      <record-details v-if="showRecordDetails" :select-detail="RecordDetails"
                      :show-dialog="showRecordDetails" @submit="close2"></record-details>
      <picture-loading v-if="loading"></picture-loading>
    </div>
  </div>
</template>

<script>
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import ExFoldCell from "@/components/ExFoldCell.vue";
import {reminder} from "@/utils/data/tableCol/reminder/reminder";
import {deleteReminders, getRemindersPage} from "@/api/dilivery/reminder";
import AddEditReminder from "@/components/reminder/AddEditReminder.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import MailDetails from "@/components/mail/MailDetails.vue";
import {getRecordPage} from "@/api/dilivery/record";
import RecordDetails from "@/components/record/RecordDetails.vue";
import {getMailPage} from "@/api/dilivery/mail";
import ExFoldForm from "@/components/ExFoldForm.vue";
import {viewDetailIcon} from "@/utils/icon";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";



export default {
  name: "Reminder",
  components: {
    PictureLoading,
    ExFoldForm, RecordDetails, MailDetails, AddEditReminder, ExFoldCell, ExFoldTable, TableHeadNote},
  mixins: [tableOperationMixin],
  data() {
    return {
      ids: [],
      loading:true,
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      showAddEditDialog: false, //控制编辑页面显示与隐藏
      selectDetail: '',
      selectType: {},
      showMailDetails:false,
      MailDetails:'',
      showRecordDetails:false,
      RecordDetails:'',
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      viewDetailIcon: viewDetailIcon,
    }
  },
  computed: {
    column() {
      let cols = reminder(this.searchConditionTag || {});
      return JSON.parse(JSON.stringify(cols))
    },
    ReminderHeaderCalled(){
      return this.$store.getters['right/getReminderHeaderCalled']
    },
  },
  mounted() {
    this.getData()
  },
  watch:{
    'ReminderHeaderCalled':{
      handler(newVal){
        if(newVal){
          this.getData()
          this.$store.commit('right/setReminderHeaderCalled', false);
        }
      }
    }
  },
  methods: {
    //已提交表格选择框
    rowSelection(selectedRows) {
      this.ids = selectedRows.map(item=>item.id)
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    showRecordInfo(id){
      let data = {
        "query#id.EQ":id
      }
      getRecordPage({},data).then(res=>{
        if(res.code === 200){
          this.RecordDetails = res.data.records[0]
          this.showRecordDetails = true
        }
      }).catch(err=>{

      })
    },
    showMailInfo(id){
      let data = {
        "query#id.EQ":id
      }
      getMailPage({},data).then(res=>{
        if(res.code === 200){
          this.MailDetails = res.data.records[0]
          this.showMailDetails = true
        }
      }).catch(err=>{

      })
    },
    // 获取邮寄表数据
    getData(type) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (type) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      this.sortConditionTag.forEach(item => {
        params["order"] = item.colName + "." + item.order
      })
      let sendData = {}
      sendData = this.getSearch(sendData)
      getRemindersPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        if (item.key==='doneFlag'){
          sendData["query#" + item.key + ".LIKE"] = item.value==='是'?1:0
        }else {
          sendData["query#" + item.key + ".LIKE"] = item.value
        }
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    //编辑表格显示列
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = 'edit'
      } else {
        this.selectType = 'add'
        this.selectDetail = ''
      }
      this.showAddEditDialog = true
    },
    // 关闭编辑、增加弹出框
    closeAddEditDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$store.commit("right/setHeaderReminderCalled",true)
      this.$nextTick(() => {
        this.showAddEditDialog = false
      })
    },
    close1(){
      this.$nextTick(() => {
        this.showMailDetails = false
      })
    },
    close2(){
      this.$nextTick(() => {
        this.showRecordDetails = false
      })
    },
    deleteInfo(row){
      let ids = []
      if (row && row.id) {
        ids.push(row.id)
      } else {
        if (this.ids.length > 0) {
          ids = this.ids
        } else {
          this.$messageUi.error('请勾选要批量删除的数据')
          return
        }
      }
      this.$confirmUi('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        let param = {
          "ids" : ids.join(',')
        }
        deleteReminders(param).then(res => {
          if (res.code === 200) {
            this.$store.commit("right/setHeaderReminderCalled",true)
            this.$messageUi({
              type: 'success',
              message: '删除成功!'
            })
            this.ids = []
            const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize)
            this.page.currentNum = this.page.currentNum > totalPage ? totalPage : this.page.currentNum
            this.page.currentNum = this.page.currentNum < 1 ? 1 : this.page.currentNum
            this.getData()
          }
        }).catch(err => {
        })
      }).catch(() => {

      })
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}
.parent-container {
  /*position: relative; !* 使子元素的绝对定位相对于父元素 *!*/
  /*overflow: hidden; !* 隐藏超出部分 *!*/
}
.add-edit-mail {
  position: absolute; /* 使对话框相对于父组件定位 */
}
</style>
